/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var GrammXQuery = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[2,14],$V1=[1,17],$V2=[1,25],$V3=[1,24],$V4=[1,31],$V5=[1,23],$V6=[1,18],$V7=[1,33],$V8=[1,32],$V9=[1,13],$Va=[1,12],$Vb=[1,14],$Vc=[1,15],$Vd=[1,16],$Ve=[1,28],$Vf=[1,26],$Vg=[1,29],$Vh=[5,9,11,12,49,51,68,71,77,81,82,83,84,85,91,96,97],$Vi=[1,36],$Vj=[5,7,9,11,12,49,51,68,71,77,81,82,83,84,85,91,96,97],$Vk=[1,37],$Vl=[5,7,9,11,12,14,38,49,51,68,71,77,79,81,82,83,84,85,91,96,97],$Vm=[1,56],$Vn=[1,64],$Vo=[1,63],$Vp=[1,55],$Vq=[1,45],$Vr=[1,46],$Vs=[1,47],$Vt=[1,48],$Vu=[1,49],$Vv=[1,50],$Vw=[1,51],$Vx=[1,52],$Vy=[1,53],$Vz=[1,54],$VA=[1,57],$VB=[1,58],$VC=[1,59],$VD=[1,60],$VE=[1,61],$VF=[1,62],$VG=[5,7,9,11,12,14,26,38,49,51,52,53,54,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,93,95,96,97,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],$VH=[2,121],$VI=[2,123],$VJ=[1,68],$VK=[2,125],$VL=[1,69],$VM=[1,106],$VN=[5,7,9,11,12,14,26,38,49,51,52,53,58,60,68,71,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97],$VO=[1,118],$VP=[1,127],$VQ=[1,123],$VR=[1,125],$VS=[1,121],$VT=[1,126],$VU=[1,128],$VV=[53,58,60,71],$VW=[1,134],$VX=[1,136],$VY=[1,135],$VZ=[5,7,9,11,12,14,26,38,49,51,52,53,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97,99,100,103,104,105,106,107,108,109,110,111,112,113],$V_=[5,7,9,11,12,14,26,38,49,51,52,53,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113],$V$=[5,7,9,11,12,14,26,38,49,51,52,53,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97,103,104,109,110],$V01=[5,7,9,11,12,14,26,38,49,51,52,53,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97,103,104,105,106,107,108,109,110,111,112,113],$V11=[1,154],$V21=[1,157],$V31=[1,156],$V41=[5,7,9,11,12,14,26,38,49,51,52,53,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,93,96,97],$V51=[9,11,12,51,71,91,94,96,97],$V61=[2,77],$V71=[2,76],$V81=[1,172],$V91=[1,173],$Va1=[5,7,14,26,38,49,52,53,55,60,68,72,77,79,81,82,83,84,85],$Vb1=[1,189],$Vc1=[5,7,9,11,12,14,26,38,49,51,52,53,58,60,68,71,73,77,79,81,82,83,84,85,87,90,91,92,96,97],$Vd1=[14,54,93,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],$Ve1=[14,26],$Vf1=[5,7,9,11,12,14,38,49,51,53,58,60,68,71,77,79,81,82,83,84,85,91,96,97],$Vg1=[1,242],$Vh1=[1,246],$Vi1=[2,37],$Vj1=[1,247],$Vk1=[1,248],$Vl1=[1,249],$Vm1=[1,250],$Vn1=[1,251],$Vo1=[1,260],$Vp1=[14,26,36,39],$Vq1=[9,11,12,38,49,51,68,71,77,91,96,97],$Vr1=[14,26,36],$Vs1=[2,25],$Vt1=[1,292];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"INICIO":3,"FUNCTION":4,"EOF":5,"METODOS":6,"RDECLARE":7,"RFUNCTION":8,"LOCAL":9,"DOSPUNTOS":10,"IDENTIFICADOR":11,"PARIZQ":12,"PARAMETROS":13,"PARDER":14,"TIPO":15,"BLOQUE":16,"PTCOMA":17,"F_SUBS":18,"F_NUMBER":19,"F_UPPER":20,"F_LOWER":21,"F_STRING":22,"LLAMADAFUNCION":23,"LET":24,"INSTRUCCION":25,"COMA":26,"DECLARACIONES":27,"VARIABLE":28,"AS":29,"XS":30,"OPTIONALQUESTION":31,"L_PARAMETROSINTERNOS":32,"TIPOPARAMETRO":33,"L_CONSULTAS":34,"EXPRESION":35,"LLAVEIZQ":36,"INSTRUCCIONES":37,"LLAVEDER":38,"QUESTION":39,"INT":40,"FLOAT":41,"CHAR":42,"DOUBLE":43,"BOOLEAN":44,"DOUBLER":45,"FORSIMPLE":46,"FORTO":47,"L_IF":48,"RFOR":49,"RIN":50,"ENTERO":51,"RTO":52,"RRETURN":53,"IGUAL":54,"AND":55,"FORCOMPUESTO":56,"CONDICIONCOMPUESTA":57,"RWHERE":58,"CONDICION":59,"RORDERBY":60,"RETORNO":61,"CONDICIONSIMPLE":62,"CONJUNCION":63,"UNION":64,"L_IN":65,"L_VARIABLES":66,"RAT":67,"RLET":68,"LETDOSPUNTOS":69,"CONECTOR":70,"DOLAR":71,"OR":72,"PUNTO":73,"FUNCIONES":74,"IF":75,"ASIGNACION":76,"RIF":77,"RTHEN":78,"RELSE":79,"RDATA":80,"RNUMBER":81,"RSUBS":82,"RUPPER":83,"RLOWER":84,"RSTRING":85,"CONSULTA":86,"BARRA":87,"OPCIONESCONSULT":88,"PREDICADO":89,"DOBLEBARRA":90,"ARROBA":91,"DOBLEPUNTO":92,"ASTERISCO":93,"CORIZQ":94,"CORDER":95,"CADENA":96,"RLAST":97,"OPERACIONESF":98,"MAS":99,"MENOS":100,"RDIV":101,"MODULO":102,"IGUALACION":103,"DIFERENCIACION":104,"MENORIGUAL":105,"MAYORIGUAL":106,"MENORQUE":107,"MAYORQUE":108,"REQUALS":109,"RNOTEQUALS":110,"RMENORIGUAL":111,"RMAYORIGUAL":112,"RMENORQUE":113,"RMAYORQUE":114,"MULTIPLICACION":115,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",7:"RDECLARE",8:"RFUNCTION",9:"LOCAL",10:"DOSPUNTOS",11:"IDENTIFICADOR",12:"PARIZQ",14:"PARDER",17:"PTCOMA",26:"COMA",29:"AS",30:"XS",36:"LLAVEIZQ",38:"LLAVEDER",39:"QUESTION",40:"INT",41:"FLOAT",42:"CHAR",43:"DOUBLE",44:"BOOLEAN",45:"DOUBLER",49:"RFOR",50:"RIN",51:"ENTERO",52:"RTO",53:"RRETURN",54:"IGUAL",55:"AND",58:"RWHERE",60:"RORDERBY",67:"RAT",68:"RLET",69:"LETDOSPUNTOS",71:"DOLAR",72:"OR",73:"PUNTO",77:"RIF",78:"RTHEN",79:"RELSE",80:"RDATA",81:"RNUMBER",82:"RSUBS",83:"RUPPER",84:"RLOWER",85:"RSTRING",87:"BARRA",90:"DOBLEBARRA",91:"ARROBA",92:"DOBLEPUNTO",93:"ASTERISCO",94:"CORIZQ",95:"CORDER",96:"CADENA",97:"RLAST",99:"MAS",100:"MENOS",101:"RDIV",102:"MODULO",103:"IGUALACION",104:"DIFERENCIACION",105:"MENORIGUAL",106:"MAYORIGUAL",107:"MENORQUE",108:"MAYORQUE",109:"REQUALS",110:"RNOTEQUALS",111:"RMENORIGUAL",112:"RMAYORIGUAL",113:"RMENORQUE",114:"RMAYORQUE",115:"MULTIPLICACION"},
productions_: [0,[3,2],[4,2],[4,1],[6,12],[6,11],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,0],[13,3],[13,1],[27,6],[32,3],[32,1],[33,1],[33,1],[16,3],[16,2],[31,1],[31,0],[15,5],[15,5],[15,5],[15,5],[15,5],[15,5],[15,1],[15,1],[15,1],[15,1],[15,1],[15,0],[37,2],[37,1],[25,1],[25,1],[25,1],[25,1],[25,1],[25,1],[47,10],[47,24],[56,8],[56,6],[56,6],[56,4],[46,8],[46,6],[46,6],[46,4],[57,3],[57,1],[57,0],[62,2],[62,1],[64,3],[64,2],[63,2],[66,3],[66,1],[24,6],[24,4],[65,1],[65,6],[65,5],[65,1],[65,1],[23,6],[23,5],[28,2],[70,1],[70,1],[70,1],[70,1],[70,1],[61,1],[61,1],[61,1],[61,1],[61,1],[48,8],[48,15],[48,17],[75,8],[75,9],[74,4],[19,4],[19,5],[18,6],[18,7],[20,4],[20,5],[21,4],[21,5],[22,4],[22,5],[76,3],[76,5],[59,2],[59,3],[59,1],[34,2],[34,1],[86,3],[86,2],[86,2],[86,2],[86,1],[88,1],[88,1],[88,1],[88,1],[88,1],[88,1],[89,3],[35,1],[35,3],[35,1],[35,1],[35,1],[35,2],[35,2],[35,3],[35,1],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[35,3],[98,3],[98,3],[98,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
return $$[$0-1];
break;
case 2: case 38: case 59: case 107:
$$[$0-1].push($$[$0]); this.$=$$[$0-1];
break;
case 3: case 16: case 19: case 39: case 60: case 65: case 108:
this.$=[$$[$0]];
break;
case 4:
this.$=new funciones.default($$[$0-6],$$[$0-4],$$[$0-2],$$[$0-1],_$[$0-11].first_line,_$[$0-11].first_column);
break;
case 5:
this.$=new funciones.default($$[$0-5],null,$$[$0-2],$$[$0-1],_$[$0-10].first_line,_$[$0-10].first_column);
break;
case 6: case 7: case 8: case 9: case 10: case 11: case 12: case 13: case 20: case 21: case 32: case 33: case 34: case 35: case 36: case 40: case 41: case 42: case 43: case 44: case 45: case 57: case 68: case 71: case 72: case 76: case 77: case 78: case 79: case 80: case 81: case 82: case 83: case 84: case 85: case 106: case 113: case 114: case 115: case 116: case 117: case 118: case 119: case 129: case 152:
this.$=$$[$0]
break;
case 14:
this.$=""
break;
case 15: case 18: case 64:
$$[$0-2].push($$[$0]); this.$=$$[$0-2];
break;
case 17:
this.$=new declaracion.default($$[$0-5],$$[$0-1],_$[$0-5].first_line,_$[$0-5].first_column);
break;
case 22: case 26: case 27: case 28: case 29: case 30: case 31: case 62: case 120: case 122:
this.$=$$[$0-1]
break;
case 23:
this.$=null
break;
case 24:
$$[$0]
break;
case 46:
this.$=new thefortosimple.default($$[$0-8],$$[$0],$$[$0-5],$$[$0-3],_$[$0-9].first_line,_$[$0-9].first_column);
break;
case 47:
this.$=new thefortocompuesto.default($$[$0-22],$$[$0-14],$$[$0-19],$$[$0-17],$$[$0-11],$$[$0-9],_$[$0-23].first_line,_$[$0-23].first_column);
break;
case 48:
this.$=$$[$0-7]+$$[$0-6]+$$[$0-5]+$$[$0-4]+$$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 49: case 50: case 69:
this.$=$$[$0-5]+$$[$0-4]+$$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 51: case 91:
this.$=$$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 52:
this.$=new theforsimple.default($$[$0-6],$$[$0],_$[$0-7].first_line,_$[$0-7].first_column,$$[$0-4],$$[$0-2]);
break;
case 53:
this.$=new theforsimple.default($$[$0-4],$$[$0],_$[$0-5].first_line,_$[$0-5].first_column,$$[$0-2],null);
break;
case 54:
this.$=new theforsimple.default($$[$0-4],$$[$0],_$[$0-5].first_line,_$[$0-5].first_column,null,$$[$0-2]);
break;
case 55:
this.$=new theforsimple.default($$[$0-2],$$[$0],_$[$0-3].first_line,_$[$0-3].first_column,null,null);
break;
case 56:
this.$=$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 61:
this.$=new condicionsimple.default($$[$0-2],$$[$0],_$[$0-2].first_line,_$[$0-2].first_column);
break;
case 63: case 75: case 111: case 112:
this.$=$$[$0-1]+$$[$0]
break;
case 66:
this.$=new thelet.default($$[$0-4],$$[$0-2],$$[$0],_$[$0-5].first_line,_$[$0-5].first_column)
break;
case 67:
this.$=new thelet.default($$[$0-2],$$[$0],null,_$[$0-3].first_line,_$[$0-3].first_column)
break;
case 70:
this.$=$$[$0-4]+$$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 73:
this.$=new llamada.default($$[$0-3],$$[$0-1],_$[$0-5].first_line,_$[$0-5].first_column);
break;
case 74:
this.$=new llamada.default($$[$0-2],null,_$[$0-4].first_line,_$[$0-4].first_column);
break;
case 86:
this.$=new thefunctionif.default($$[$0-5],$$[$0-2],_$[$0-7].first_line,_$[$0-7].first_column,$$[$0],null)
break;
case 87:
this.$=new theifAnidado.default($$[$0-12],$$[$0-9],$$[$0-5],$$[$0-2],$$[$0],_$[$0-14].first_line,_$[$0-14].first_column)
break;
case 88:
this.$=new theifAnidado.default($$[$0-14],$$[$0-11],$$[$0-7],$$[$0-4],$$[$0-1],_$[$0-16].first_line,_$[$0-16].first_column)
break;
case 89:
this.$=new theif.default($$[$0-5],_$[$0-7].first_line,_$[$0-7].first_column,$$[$0-2],$$[$0])
break;
case 90:
this.$=new theif.default($$[$0-6],_$[$0-8].first_line,_$[$0-8].first_column,$$[$0-3],null)
break;
case 92:
this.$=new number.default($$[$0-1],_$[$0-3].first_line,_$[$0-3].first_column)
break;
case 93:
this.$=new number.default($$[$0-2],_$[$0-4].first_line,_$[$0-4].first_column)
break;
case 94:
this.$=new subs.default($$[$0-3],$$[$0-1],_$[$0-5].first_line,_$[$0-5].first_column)
break;
case 95:
this.$=new subs.default($$[$0-4],$$[$0-2],_$[$0-6].first_line,_$[$0-6].first_column)
break;
case 96:
this.$=new upper.default($$[$0-1],_$[$0-3].first_line,_$[$0-3].first_column)
break;
case 97:
this.$=new upper.default($$[$0-2],_$[$0-4].first_line,_$[$0-4].first_column)
break;
case 98:
this.$=new lower.default($$[$0-1],_$[$0-3].first_line,_$[$0-3].first_column)
break;
case 99:
this.$=new lower.default($$[$0-2],_$[$0-4].first_line,_$[$0-4].first_column)
break;
case 100:
this.$=new string.default($$[$0-1],_$[$0-3].first_line,_$[$0-3].first_column)
break;
case 101:
this.$=new string.default($$[$0-2],_$[$0-4].first_line,_$[$0-4].first_column)
break;
case 102: case 141:
this.$=new asignacion.default($$[$0-2],$$[$0],_$[$0-2].first_line,_$[$0-2].first_column);
break;
case 103:
this.$=new asignacion.default($$[$0-4],$$[$0-2],_$[$0-4].first_line,_$[$0-4].first_column);
break;
case 104:
this.$=new condicionsimple.default($$[$0-1],$$[$0],_$[$0-1].first_line,_$[$0-1].first_column);
break;
case 105:
this.$=new condicion.default($$[$0-1],_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 109:
this.$ = new barrasnodo.default($$[$0-2],$$[$0],_$[$0-2].first_line,_$[$0-2].first_column, $$[$0-1]);
break;
case 110:
this.$ = new barrasnodo.default($$[$0-1],$$[$0],_$[$0-1].first_line,_$[$0-1].first_column, null);
break;
case 121:
this.$=new nativo.default(new Tipo.default(Tipo.tipoDato.ENTERO),$$[$0],_$[$0].first_line,_$[$0].first_column);
break;
case 123:
this.$ = new identificador.default($$[$0],_$[$0].first_line,_$[$0].first_column);
break;
case 124:
this.$=new nativo.default(new Tipo.default(Tipo.tipoDato.CADENA),$$[$0],_$[$0].first_line,_$[$0].first_column);
break;
case 125:
this.$ = new variable.default($$[$0],_$[$0].first_line,_$[$0].first_column);
break;
case 126:
this.$ = new atributosexpresion.default($$[$0-1],$$[$0],_$[$0-1].first_line,_$[$0-1].first_column);
break;
case 127:
this.$ = new identificadorpredicado.default($$[$0-1],$$[$0],_$[$0-1].first_line,_$[$0-1].first_column);
break;
case 128:
this.$=$$[$0-2]+"()"
break;
case 130:
this.$=new aritmetica.default(aritmetica.Operadores.SUMA,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 131:
this.$=new aritmetica.default(aritmetica.Operadores.RESTA,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 132:
this.$=new aritmetica.default(aritmetica.Operadores.DIVISION,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 133:
this.$=new aritmetica.default(aritmetica.Operadores.MODULADOR,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 134: case 142:
this.$=new relacional.default(relacional.Relacionales.IGUAL,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 135: case 143:
this.$=new relacional.default(relacional.Relacionales.DIFERENTE,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 136: case 144:
this.$=new relacional.default(relacional.Relacionales.MENORIGUAL,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 137: case 145:
this.$=new relacional.default(relacional.Relacionales.MAYORIGUAL,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 138: case 146:
this.$=new relacional.default(relacional.Relacionales.MENORQUE,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 139: case 147:
this.$=new relacional.default(relacional.Relacionales.MAYORQUE,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 140:
this.$=new aritmetica.default(aritmetica.Operadores.MULTIPLICACION,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 148:
this.$=new logica.default(logica.Logicas.OR,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 149:
this.$=new logica.default(logica.Logicas.AND,_$[$0-2].first_line,_$[$0-2].first_column,$$[$0-2],$$[$0]);
break;
case 150: case 151:
this.$=$$[$0-2]+$$[$0-1]+$$[$0] 
break;
}
},
table: [o([5,7],$V0,{3:1,4:2,6:3,18:4,19:5,20:6,21:7,22:8,23:9,24:10,25:11,35:19,46:20,47:21,48:22,28:27,98:30,9:$V1,11:$V2,12:$V3,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,81:$V9,82:$Va,83:$Vb,84:$Vc,85:$Vd,91:$Ve,96:$Vf,97:$Vg}),{1:[3]},{5:[1,34],6:35,7:$V0,9:$V1,11:$V2,12:$V3,18:4,19:5,20:6,21:7,22:8,23:9,24:10,25:11,28:27,35:19,46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,81:$V9,82:$Va,83:$Vb,84:$Vc,85:$Vd,91:$Ve,96:$Vf,97:$Vg,98:30},o($Vh,[2,3],{7:$Vi}),o($Vj,[2,6]),o($Vj,[2,7]),o($Vj,[2,8]),o($Vj,[2,9]),o($Vj,[2,10]),o([5,7,9,11,12,49,51,54,55,68,71,72,77,81,82,83,84,85,91,93,96,97,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],[2,11],{99:$Vk}),o($Vj,[2,12]),o($Vj,[2,13]),{12:[1,38]},{12:[1,39]},{12:[1,40]},{12:[1,41]},{12:[1,42]},{10:[1,43]},{28:44,71:$V7},o($Vl,[2,40],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($Vl,[2,41]),o($Vl,[2,42]),o($Vl,[2,45]),o($VG,$VH),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:65,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o($VG,$VI,{89:67,94:$VJ}),o($VG,[2,124]),o($VG,$VK,{115:$VL}),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:70,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{12:[1,71]},o($VG,[2,129]),{28:73,62:72,64:74,71:$V7},{12:[1,75]},{11:[1,76]},{1:[2,1]},o($Vh,[2,2],{7:$Vi}),{8:[1,77]},{9:$V1,23:78},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:79,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:80,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:81,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:82,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:83,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{11:[1,84]},{69:[1,85]},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:86,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:87,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:88,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:89,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:90,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:91,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:92,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:93,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:94,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:95,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:96,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:97,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:98,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:99,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:100,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:101,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:102,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:103,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:104,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:105,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{14:$VM,54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},o([5,7,9,11,12,14,26,38,49,51,52,53,54,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,93,95,96,97,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],[2,152],{99:$Vk}),o($VG,[2,127]),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:107,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,23:108},o($VN,[2,126],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),{14:[1,109]},{28:114,53:[1,112],58:[1,110],60:[1,111],64:113,71:$V7},{9:$V1,11:$V2,12:$VO,23:119,28:27,34:120,35:117,50:[1,115],51:$V5,65:116,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},o($VV,[2,60]),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:129,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o([5,7,9,11,12,14,26,29,38,49,50,51,52,53,54,55,58,60,68,69,71,72,73,77,79,81,82,83,84,85,87,90,91,92,93,95,96,97,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115],[2,75]),{9:[1,130]},o($VG,[2,151]),{26:$VW,52:$VX,54:$Vm,55:[1,133],70:131,72:[1,132],73:$VY,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{14:[1,137],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{14:[1,138],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{14:[1,139],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{14:[1,140],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{12:[1,141]},{9:$V1,11:$V2,12:$VO,23:119,28:27,34:120,35:117,50:[1,143],51:$V5,65:142,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},o($VZ,[2,130],{54:$Vm,93:$Vp,101:$Vs,102:$Vt,114:$VF}),o($VZ,[2,131],{54:$Vm,93:$Vp,101:$Vs,102:$Vt,114:$VF}),o($V_,[2,132],{54:$Vm,93:$Vp,114:$VF}),o($V_,[2,133],{54:$Vm,93:$Vp,114:$VF}),o($V$,[2,134],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,105:$Vw,106:$Vx,107:$Vy,108:$Vz,111:$VC,112:$VD,113:$VE,114:$VF}),o($V$,[2,135],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,105:$Vw,106:$Vx,107:$Vy,108:$Vz,111:$VC,112:$VD,113:$VE,114:$VF}),o($V01,[2,136],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($V01,[2,137],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($V01,[2,138],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($V01,[2,139],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($VN,[2,140],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($VN,[2,141],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($V$,[2,142],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,105:$Vw,106:$Vx,107:$Vy,108:$Vz,111:$VC,112:$VD,113:$VE,114:$VF}),o($V$,[2,143],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,105:$Vw,106:$Vx,107:$Vy,108:$Vz,111:$VC,112:$VD,113:$VE,114:$VF}),o($V01,[2,144],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($V01,[2,145],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($V01,[2,146],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,114:$VF}),o($VN,[2,147],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o([5,7,9,11,12,14,26,38,49,51,52,53,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97],[2,148],{54:$Vm,55:$Vn,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o([5,7,9,11,12,14,26,38,49,51,52,53,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,95,96,97],[2,149],{54:$Vm,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($VG,[2,122]),{54:$Vm,55:$Vn,72:$Vo,93:$Vp,95:[1,144],99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},o($VG,[2,150]),o($VG,[2,128]),{28:146,59:145,71:$V7},{28:146,59:147,71:$V7},{9:$V1,11:$V11,12:$V3,23:66,28:155,35:149,51:$V5,59:153,61:148,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},o($VV,[2,59]),{9:$V1,11:$V2,12:$VO,23:119,28:27,34:120,35:117,50:[1,158],51:$V5,65:116,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:[1,159],23:66,28:27,34:160,35:161,51:$V5,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},o($VV,[2,62]),o([5,7,9,11,12,14,38,49,51,53,58,60,68,71,73,77,79,81,82,83,84,85,87,90,91,92,96,97],[2,68],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:65,51:[1,162],71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o([5,7,9,11,12,14,38,49,51,53,54,55,58,60,68,71,72,73,77,79,81,82,83,84,85,87,90,91,92,93,96,97,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],[2,71],{99:$Vk}),o([5,7,14,38,49,53,58,60,68,77,79,81,82,83,84,85],[2,72],{28:27,98:30,23:66,88:124,35:161,86:163,9:$V1,11:$V2,12:$V3,51:$V5,71:$V7,73:$VP,87:$VQ,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg}),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:70,51:$V5,71:$V7,91:$Ve,94:[2,116],96:$Vf,97:$Vg,98:30},o($V41,[2,108]),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:165,51:$V5,71:$V7,87:[1,164],91:$Ve,94:[2,114],96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:166,51:$V5,71:$V7,89:167,91:$Ve,94:$VJ,96:$Vf,97:$Vg,98:30},o($V51,[2,115]),o($V51,[2,117]),o($V51,[2,118]),o($V51,[2,119]),{14:[1,168],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{10:[1,169]},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:170,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V61,23:66,28:27,35:104,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V71,23:66,28:27,35:105,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o($Vj,[2,78]),o($Vj,[2,79]),o($Vj,[2,80]),o($Vj,[2,92],{70:171,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o($Vj,[2,96],{70:174,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o($Vj,[2,98],{70:175,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o($Vj,[2,100],{70:176,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),{9:$V1,11:$V2,12:$V3,14:[1,178],23:66,28:27,32:177,33:179,34:180,35:181,51:$V5,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},o($Vl,[2,67],{53:[1,182]}),{12:[1,183]},o($VG,[2,120]),{26:$VW,52:$VX,53:[1,185],55:$V81,60:[1,184],70:186,72:$V91,73:$VY},o($Va1,[2,106],{28:27,98:30,23:66,86:122,88:124,35:161,34:187,9:$V1,11:$V2,12:$V3,51:$V5,71:$V7,73:$VP,87:$VQ,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg}),{26:$VW,52:$VX,53:[1,188],55:$V81,70:186,72:$V91,73:$VY},o($Vl,[2,55]),o($Vl,[2,81],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($Vl,[2,82]),o($Vl,[2,83]),o($Vl,[2,84]),o($Vl,[2,85],{70:186,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o([5,7,9,11,12,14,38,49,51,55,68,71,72,77,79,81,82,83,84,85,91,93,96,97,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],$VI,{89:67,54:$Vb1,94:$VJ}),o([5,7,14,26,38,49,52,54,55,68,72,77,79,81,82,83,84,85,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],$VK,{28:27,98:30,23:66,86:122,88:124,35:161,34:187,9:$V1,11:$V2,12:$V3,51:$V5,71:$V7,73:$VP,87:$VQ,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,115:$VL}),{12:[1,190]},{12:[1,191]},{9:$V1,11:$V2,12:[1,192],23:66,28:27,34:160,35:161,51:$V5,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:65,51:[1,193],71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o([53,58,60],[2,61],{28:27,98:30,23:66,88:124,35:161,86:163,9:$V1,11:$V2,12:$V3,51:$V5,71:$V7,73:$VP,87:$VQ,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg}),o($Vc1,[2,113],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($Vd1,$VH,{70:194,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o($V41,[2,107]),{9:$V1,11:$V2,12:$V3,23:66,28:27,35:195,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o($Vc1,[2,110],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($Vc1,[2,111],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),o($V41,[2,112]),{78:[1,196]},{11:[1,197]},{14:[1,198],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},o($Vj,[2,93]),o($Vj,$V71),o($Vj,$V61),o($Vj,[2,97]),o($Vj,[2,99]),o($Vj,[2,101]),{14:[1,199],26:[1,200]},o($VG,[2,74]),o($Ve1,[2,19]),o($Ve1,[2,20],{28:27,98:30,23:66,88:124,35:161,86:163,9:$V1,11:$V2,12:$V3,51:$V5,71:$V7,73:$VP,87:$VQ,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg}),o([9,11,12,14,26,51,71,73,87,90,91,92,96,97],[2,21],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),{9:$V1,11:$V11,12:$V3,23:66,28:155,35:149,51:$V5,59:153,61:201,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},{51:[1,202]},{28:146,59:203,71:$V7},{9:$V1,11:$V11,12:$V3,23:66,28:155,35:149,51:$V5,59:153,61:204,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},{28:146,59:205,71:$V7},o($Va1,[2,104],{28:27,98:30,23:66,88:124,35:161,86:163,9:$V1,11:$V2,12:$V3,51:$V5,71:$V7,73:$VP,87:$VQ,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg}),{9:$V1,11:$V11,12:$V3,23:66,28:155,35:149,51:$V5,59:153,61:206,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},{28:207,71:$V7},{28:146,59:208,71:$V7},{28:146,59:209,71:$V7},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:65,51:[1,210],71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},o($Vd1,$VH,{70:213,26:[1,212],52:[1,211],55:$V81,72:$V91,73:$VY}),{51:[1,214]},o($Vc1,[2,109],{54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF}),{9:$V1,11:$V2,12:$V3,23:217,24:216,25:215,28:27,35:19,46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,91:$Ve,96:$Vf,97:$Vg,98:30},{12:[1,218]},o($Vj,[2,94],{70:219,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o($VG,[2,73]),{9:$V1,11:$V2,12:$V3,23:66,28:27,33:220,34:180,35:181,51:$V5,71:$V7,73:$VP,86:122,87:$VQ,88:124,90:$VR,91:$VS,92:$VT,93:$VU,96:$Vf,97:$Vg,98:30},o($Vl,[2,66]),{26:$VW,52:$VX,55:$V81,70:213,72:$V91,73:$VY},{26:$VW,52:$VX,53:[1,221],55:$V81,70:186,72:$V91,73:$VY},o($Vl,[2,53]),o([5,7,9,11,12,14,38,49,51,53,60,68,71,77,79,81,82,83,84,85,91,96,97],[2,105],{70:186,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),o($Vl,[2,54]),o($Vl,[2,102],{70:222,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),{14:[1,223],26:$VW,52:$VX,55:$V81,70:186,72:$V91,73:$VY},{14:[1,224],26:$VW,52:$VX,55:$V81,70:186,72:$V91,73:$VY},o($Vd1,$VH,{70:213,26:$VW,52:$VX,55:$V81,72:$V91,73:$VY}),{51:[1,225]},{51:[1,226]},{51:[1,227]},{14:[1,228]},{79:[1,229]},o($Vl,[2,43]),o([5,7,9,11,12,14,38,49,51,54,55,68,71,72,77,79,81,82,83,84,85,91,93,96,97,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114],[2,44],{99:$Vk}),{13:230,14:[1,231],27:232,28:233,71:$V7},o($Vj,[2,95]),o($Ve1,[2,18]),{9:$V1,11:$V11,12:$V3,23:66,28:155,35:149,51:$V5,59:153,61:234,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},{11:[1,236],76:235},o($Vl,[2,91]),{78:[1,237]},{14:[1,238]},{14:[1,239]},{14:[1,240]},o($Vf1,[2,70]),{9:$V1,11:$V2,12:$V3,23:217,24:216,25:241,28:27,35:19,46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$Vg1,91:$Ve,96:$Vf,97:$Vg,98:30},{14:[1,243],26:[1,244]},{15:245,29:$Vh1,36:$Vi1,40:$Vj1,41:$Vk1,42:$Vl1,43:$Vm1,44:$Vn1},o($Ve1,[2,16]),{29:[1,252]},o($Vl,[2,52]),o($Vl,[2,103]),{54:$Vb1},{9:$V1,11:$V11,12:$V3,23:66,28:155,35:149,51:$V5,59:153,61:253,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},{53:[1,254]},{26:[1,255]},o($Vf1,[2,69]),o($Vl,[2,86]),{12:[1,256]},{15:257,29:$Vh1,36:$Vi1,40:$Vj1,41:$Vk1,42:$Vl1,43:$Vm1,44:$Vn1},{27:258,28:233,71:$V7},{16:259,36:$Vo1},{30:[1,261]},o($Vp1,[2,32]),o($Vp1,[2,33]),o($Vp1,[2,34]),o($Vp1,[2,35]),o($Vp1,[2,36]),{30:[1,262]},{79:[1,263]},{28:264,71:$V7},{28:265,71:$V7},{9:$V1,11:$V2,12:$V3,23:66,28:27,35:266,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{16:267,36:$Vo1},o($Ve1,[2,15]),{17:[1,268]},{9:$V1,11:$V2,12:$V3,23:217,24:216,25:271,28:27,35:19,37:269,38:[1,270],46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,91:$Ve,96:$Vf,97:$Vg,98:30},{10:[1,272]},{10:[1,273]},{9:$V1,11:$V11,12:[1,275],23:66,28:155,35:149,51:$V5,59:153,61:274,71:$V7,74:150,75:151,76:152,77:$V21,80:$V31,91:$Ve,96:$Vf,97:$Vg,98:30},o($Vl,[2,46]),{50:[1,276]},{14:[1,277],54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{17:[1,278]},o($Vj,[2,5]),{9:$V1,11:$V2,12:$V3,23:217,24:216,25:280,28:27,35:19,38:[1,279],46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,91:$Ve,96:$Vf,97:$Vg,98:30},{17:[2,23]},o($Vq1,[2,39]),{40:[1,281],41:[1,282],42:[1,283],43:[1,284],44:[1,285],45:[1,286]},o([14,26,39],$Vi1,{15:287,29:$Vh1,40:$Vj1,41:$Vk1,42:$Vl1,43:$Vm1,44:$Vn1}),o($Vl,[2,89]),{9:$V1,11:$V2,12:$V3,14:[1,288],23:66,28:27,35:65,51:$V5,71:$V7,91:$Ve,96:$Vf,97:$Vg,98:30},{12:[1,289]},{78:[1,290]},o($Vj,[2,4]),{17:[2,22]},o($Vq1,[2,38]),o($Vr1,$Vs1,{31:291,39:$Vt1}),o($Vr1,$Vs1,{31:293,39:$Vt1}),o($Vr1,$Vs1,{31:294,39:$Vt1}),o($Vr1,$Vs1,{31:295,39:$Vt1}),o($Vr1,$Vs1,{31:296,39:$Vt1}),o($Vr1,$Vs1,{31:297,39:$Vt1}),o($Ve1,$Vs1,{31:298,39:$Vt1}),o($Vl,[2,90]),{51:[1,299]},{9:$V1,11:$V2,12:$V3,23:217,24:216,25:300,28:27,35:19,46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,91:$Ve,96:$Vf,97:$Vg,98:30},o($Vp1,[2,26]),o($Vp1,[2,24]),o($Vp1,[2,27]),o($Vp1,[2,28]),o($Vp1,[2,29]),o($Vp1,[2,30]),o($Vp1,[2,31]),o($Ve1,[2,17]),{26:[1,301]},{79:[1,302]},{51:[1,303]},{9:$V1,11:$V2,12:[1,305],23:217,24:216,25:304,28:27,35:19,46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$Vg1,91:$Ve,96:$Vf,97:$Vg,98:30},{14:[1,306]},o($Vl,[2,87]),{9:$V1,11:$V2,12:$V3,23:217,24:216,25:307,28:27,35:308,46:20,47:21,48:22,49:$V4,51:$V5,68:$V6,71:$V7,77:$V8,91:$Ve,96:$Vf,97:$Vg,98:30},{53:[1,309]},{14:[1,310]},{14:$VM,54:$Vm,55:$Vn,72:$Vo,93:$Vp,99:$Vq,100:$Vr,101:$Vs,102:$Vt,103:$Vu,104:$Vv,105:$Vw,106:$Vx,107:$Vy,108:$Vz,109:$VA,110:$VB,111:$VC,112:$VD,113:$VE,114:$VF},{11:[1,311]},o($Vl,[2,88]),{54:[1,312]},{28:313,71:$V7},{55:[1,314]},{11:[1,315]},{54:[1,316]},{28:317,71:$V7},o($Vl,[2,47])],
defaultActions: {34:[2,1],270:[2,23],279:[2,22]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

    const thefortosimple = require('./Instrucciones/ForToSimple');
    const thefortocompuesto = require('./Instrucciones/ForToCompuesto');

    const theforsimple = require('./Instrucciones/ForSimple');
    const atributosexpresion = require("../../XPATH/Analizador/Instrucciones/AtributosSimples")
    const identificadorpredicado = require("../../XPATH/Analizador/Instrucciones/IdentificadorPredicado")
    const aritmetica= require("./Expresiones/Aritmetica");
    const logica = require ("./Expresiones/Logica");
    const relacional = require("./Expresiones/Relacional");
    const barrasnodo= require("./Instrucciones/BarrasNodo")
    const identificador= require("./Expresiones/Identificador");
    const variable= require("./Expresiones/Variable");
    const nativo= require("./Expresiones/Nativo");
    const asignacion= require("./Instrucciones/Asignacion")
    const funciones= require("./Instrucciones/Funciones")
    const declaracion= require("./Instrucciones/Declaracion")
    const llamada= require("./Instrucciones/Llamada")
    const theif = require('./Instrucciones/If')
    const thelet=require('./Instrucciones/Let')
    const Tipo= require("./Simbolos/Tipo");
    const condicionsimple= require("./Instrucciones/CondicionSimple");
    const condicion= require("./Instrucciones/Condicion");
    const lower=require("./Funciones/Lower");
    const number=require("./Funciones/Number");
    const string=require("./Funciones/String");
    const upper=require("./Funciones/Upper");
    const subs=require("./Funciones/Substring");
    const thefunctionif=require('./Instrucciones/IfFuncion');
    const theifAnidado=require('./Instrucciones/IfFuncionAnidado');
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-sensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:
break;
case 1:
break;
case 2:
break;
case 3:
break;
case 4:
break;
case 5:
break;
case 6:return 29;
break;
case 7:return 30;
break;
case 8:return 49;
break;
case 9:return 68;
break;
case 10:return 58;
break;
case 11:return 60;
break;
case 12:return 53;
break;
case 13:return 50;
break;
case 14:return 'RDOC';
break;
case 15:return 77;
break;
case 16:return 79;
break;
case 17:return 78;
break;
case 18:return 109;
break;
case 19:return 110;
break;
case 20:return 113;
break;
case 21:return 111;
break;
case 22:return 114;
break;
case 23:return 112;
break;
case 24:return 67;
break;
case 25:return 52;
break;
case 26:return 7;
break;
case 27:return 8;
break;
case 28:return 101;
break;
case 29:return 72;
break;
case 30:return 55;
break;
case 31:return 102;
break;
case 32:return 'RNODO';
break;
case 33:return 'RTEXT';
break;
case 34:return 80;
break;
case 35:return 97;
break;
case 36:return 9;
break;
case 37:return 81;
break;
case 38:return 85;
break;
case 39:return 40
break;
case 40:return 43
break;
case 41:return 45
break;
case 42:return 41 
break;
case 43:return 42
break;
case 44:return 44
break;
case 45:return 83;
break;
case 46:return 84;
break;
case 47:return 82;
break;
case 48:return 93;
break;
case 49:return 12;
break;
case 50:return 14;    
break;
case 51:return 92;
break;
case 52:return 73;
break;
case 53:return 90;
break;
case 54:return 87;
break;
case 55:return 94;
break;
case 56:return 95;
break;
case 57:return 71;
break;
case 58:return 106;
break;
case 59:return 'MENORQUECIERRE';
break;
case 60:return 105;
break;
case 61:return 107;
break;
case 62:return 108;
break;
case 63:return 36;
break;
case 64:return 38;
break;
case 65:return 104;
break;
case 66:return 54;
break;
case 67:return 103;
break;
case 68:return 99;
break;
case 69:return 100;
break;
case 70:return 115;
break;
case 71:return 'POTENCIA';
break;
case 72:return 102;
break;
case 73:return 'POTENCIA';
break;
case 74:return 91;
break;
case 75:return 26;
break;
case 76:return 69;
break;
case 77:return 10;
break;
case 78:return 17;
break;
case 79:return 39;
break;
case 80: yy_.yytext=yy_.yytext.substr(1,yy_.yyleng-2); return 96; 
break;
case 81: yy_.yytext=yy_.yytext.substr(1,yy_.yyleng-2); return 'QUOTE'; 
break;
case 82:return 11;
break;
case 83:return 51;
break;
case 84:return 5
break;
case 85:console.log("Error Lexico");
break;
}
},
rules: [/^(?:[(][:][^:]*[:]+[)])/,/^(?:[ \r\t]+)/,/^(?:\s+)/,/^(?:\n+)/,/^(?:\/\/.*)/,/^(?:[/][][^][]+([^/][^][]+)*[/])/,/^(?:as\b)/,/^(?:xs\b)/,/^(?:for\b)/,/^(?:let\b)/,/^(?:where\b)/,/^(?:order by\b)/,/^(?:return\b)/,/^(?:in\b)/,/^(?:doc\b)/,/^(?:if\b)/,/^(?:else\b)/,/^(?:then\b)/,/^(?:eq\b)/,/^(?:ne\b)/,/^(?:lt\b)/,/^(?:le\b)/,/^(?:gt\b)/,/^(?:ge\b)/,/^(?:at\b)/,/^(?:to\b)/,/^(?:declare\b)/,/^(?:function\b)/,/^(?:div\b)/,/^(?:or\b)/,/^(?:and\b)/,/^(?:mod\b)/,/^(?:node\b)/,/^(?:text\b)/,/^(?:data\b)/,/^(?:last\b)/,/^(?:local\b)/,/^(?:number\b)/,/^(?:string\b)/,/^(?:integer\b)/,/^(?:decimal\b)/,/^(?:double\b)/,/^(?:float\b)/,/^(?:char\b)/,/^(?:boolean\b)/,/^(?:upper-case\b)/,/^(?:lower-case\b)/,/^(?:substring\b)/,/^(?:\*)/,/^(?:\()/,/^(?:\))/,/^(?:\.\.)/,/^(?:\.)/,/^(?:\/\/)/,/^(?:\/)/,/^(?:\[)/,/^(?:\])/,/^(?:\$)/,/^(?:>=)/,/^(?:<\/)/,/^(?:<=)/,/^(?:<)/,/^(?:>)/,/^(?:\{)/,/^(?:\})/,/^(?:!=)/,/^(?:=)/,/^(?:==)/,/^(?:\+)/,/^(?:-)/,/^(?:\*)/,/^(?:\^)/,/^(?:%)/,/^(?:\^)/,/^(?:@)/,/^(?:,)/,/^(?::=)/,/^(?::)/,/^(?:;)/,/^(?:\?)/,/^(?:"[^\"]*")/,/^(?:'[^\']*')/,/^(?:([a-zA-Z_À-ÿ\u00F1\u00D1])[a-zA-Z0-9_^ÑñÀ-ÿ\-\.\u00F1\u00D10-9_]*)/,/^(?:[0-9]+(\.[0-9]+)?\b)/,/^(?:$)/,/^(?:.)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = GrammXQuery;
exports.Parser = GrammXQuery.Parser;
exports.parse = function () { return GrammXQuery.parse.apply(GrammXQuery, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}